module.exports = __webpack_public_path__ + "img/step39_a_stacker_final.604dc913.png";